
function GetKeyBoard(){
    let number = [], attach ={};
    let num = upset(['0','1','2','3','4','5','6','7','8','9']);
    for(let i=0;i<=9;i++){
        attach['key'+i] = num[i];
        number.push({keyName:num[i],value:i})
    }
    return {number:number,attach:attach};
}
function upset(list){
    let len = list.length, newArr = [];
    for(let i=0; i<len; i++){
        let index = Math.floor(Math.random()*list.length);//随机下标
        newArr.push(list[index]);//将随机出的元素，存放新数组newArr中去
        list.splice(index,1);//    将随机出的元素在arr中删除
    }
    //arr中删除随机出的元素,arr.length-1,同时i++,导致循环不会10次,会是5次.最后得到newArr中只有一半的随机数字,arr中剩下另一半. 将其合并到一起,得到res
    return [...newArr,...list];
}

export default GetKeyBoard;